import { useEffect, useState } from "react";
import Spacing from "../Spacing";
import StepOne from "../Steps/StepOne";
import StepTwo from "../Steps/StepTwo";
import StepThree from "../Steps/StepThree";
import StepFour from "../Steps/StepFour";
import StepNominee from "../Steps/StepNominee";
import StepPlan from "../Steps/StepPlan";
import { useDispatch, useSelector } from "react-redux";
import {
  addFamilyDetails,
  dispatchNominees,
  addHealthCondition,
  addPolicyDetails,
  addSpecificIllness,
  updateUserData,
} from "../../redux/user/userSlice";
import useAuthToken from "../../hooks/useAuthToken";
// import { useNavigate } from "react-router-dom";
import Stepper from "../Stepper";
import axios from "axios";
import Departments from "./Departments";
import Doctors from "./Doctors";
import { set } from "date-fns";

// const contactInfo = [
//   { title: "Phone", subTitle: "+91 9995159567" },
//   { title: "Email Us", subTitle: "info@getafixmd.com" },
//   {
//     title: "Our Location",
//     subTitle:
//       "Kerala Start Up Mission, 2 nd Floor Admin Block, Govt Polytechnic, Pollachi road, Koottupatha, Palakkad",
//   },
// ];

const points = [3, 4.5, 5, 6];

export default function Onboarding() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const [loading, setLoading] = useState(false);
  const policy_details = useSelector((state) => state.user.policy_details);
  const family_details = useSelector((state) => state.user.family_details);
  const health_condition = useSelector((state) => state.user.health_condition);
  const specific_illness = useSelector((state) => state.user.specific_illness);
  const [isChecked, setIsChecked] = useState(false);
  const token = useAuthToken();

  const [viewContactInfo, setViewContactInfo] = useState(true);
  const [stepTwo, setStepTwo] = useState(true);
  const [stepThree, setStepThree] = useState(false);
  const [stepFour, setStepFour] = useState(false);
  const [stepFive, setStepFive] = useState(false);
  const [stepNominee, setStepNominee] = useState(false);
  const [stepPlan, setStepPlan] = useState(false);

  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [insured, setInsuredValue] = useState(
    user?.user?.is_insured_other ? "YES" : "NO"
  );
  const [policyNumber, setPolicyNumber] = useState(null);
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [validUpto, setValidUpto] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [currentValue, setCurrentValue] = useState("");
  const [provider, setProvider] = useState("");
  const [deductable, setDeductable] = useState(points[0]);
  const [emailvalidation, setEmailValidation] = useState(false);
  const [consent, setConsent] = useState(false);

  const [isHealthy, setIsHealthy] = useState(user?.user?.is_healthy ? "YES" : "NO");
  const [isSpecificIllness, setIsSpecificIllness] = useState(
    user?.user?.is_specific_illness ? "YES" : "NO"
  );
  const [otherDiseases, setOtherDiseases] = useState(
    user?.user?.other_diseases
  );

  const [branches, setBranches] = useState([]);
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    if (user?.user?.existing_policy) {
      setCurrentValue(user?.user?.existing_policy?.current_value);
      setProvider(user?.user?.existing_policy?.provider);
      setDeductable(user?.user?.existing_policy?.deductible_price ?? points[0]);
    }
  }, [user]);

  const [familyDetails, setFamilyDetails] = useState({
    isPart: typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.isPart ?? "NO"
      : JSON.parse(user?.user?.family_detials || "{}")?.isPart ?? "NO",
    associationGroup: typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.associationGroup ?? ""
      : JSON.parse(user?.user?.family_detials || "{}")?.associationGroup ?? "",
    insuranceType: user?.user?.insurance_type ?? "SELF",
    email: user?.user?.email ?? "",
    state: typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.state ?? ""
      : JSON.parse(user?.user?.family_detials || "{}")?.state ?? "",
    district: typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.district ?? ""
      : JSON.parse(user?.user?.family_detials || "{}")?.district ?? "",
    type: typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.type ?? ""
      : JSON.parse(user?.user?.family_detials || "{}")?.type ?? "",
    // place: typeof user?.user?.family_detials === "object"
    //   ? user?.user?.family_detials?.place ?? ""
    //   : JSON.parse(user?.user?.family_detials || "{}")?.place ?? "",

    primaryInsured: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.primaryInsured?.name
          : JSON.parse(user?.user?.family_detials)?.["primaryInsured"][
          "name"
          ]) ?? user?.user?.name,
      dob:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.primaryInsured?.dob
          : JSON.parse(user?.user?.family_detials)?.["primaryInsured"][
          "dob"
          ]) ?? user?.user?.dob,
      gender:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.primaryInsured?.gender
          : JSON.parse(user?.user?.family_detials)?.["primaryInsured"][
          "gender"
          ]) ?? user?.user?.gender,
      address:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.primaryInsured?.address
          : JSON.parse(user?.user?.family_detials)?.["primaryInsured"][
          "address"
          ]) ?? user?.user?.address,
      abhaId:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.primaryInsured?.abhaId
          : JSON.parse(user?.user?.family_detials)?.["primaryInsured"][
          "abhaId"
          ]) ?? user?.user?.abhaId,
    },
    secondAdult: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondAdult?.name
          : JSON.parse(user?.user?.family_detials)?.["secondAdult"]["name"]) ??
        "",
      dob:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondAdult?.dob
          : JSON.parse(user?.user?.family_detials)?.["secondAdult"]["dob"]) ??
        "",
      gender:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondAdult?.gender
          : JSON.parse(user?.user?.family_detials)?.["secondAdult"]["gender"]) ??
        "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondAdult?.relationship
          : JSON.parse(user?.user?.family_detials)?.["secondAdult"][
          "relationship"
          ]) ?? "",
      phone:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondAdult?.phone
          : JSON.parse(user?.user?.family_detials)?.["secondAdult"][
          "phone"
          ]) ?? "",
    },
    firstChild: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.firstChild?.name
          : JSON.parse(user?.user?.family_detials)?.["firstChild"]["name"]) ??
        "",
      dob:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.firstChild?.dob
          : JSON.parse(user?.user?.family_detials)?.["firstChild"]["dob"]) ?? "",
      gender:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.firstChild?.gender
          : JSON.parse(user?.user?.family_detials)?.["firstChild"]["gender"]) ??
        "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.firstChild?.relationship
          : JSON.parse(user?.user?.family_detials)?.["firstChild"][
          "relationship"
          ]) ?? "",
    },
    secondChild: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondChild?.name
          : JSON.parse(user?.user?.family_detials)?.["secondChild"]["name"]) ??
        "",
      dob:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondChild?.dob
          : JSON.parse(user?.user?.family_detials)?.["secondChild"]["dob"]) ??
        "",
      gender:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondChild?.gender
          : JSON.parse(user?.user?.family_detials)?.["secondChild"]["gender"]) ??
        "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.secondChild?.relationship
          : JSON.parse(user?.user?.family_detials)?.["secondChild"][
          "relationship"
          ]) ?? "",
    },
    nomineeOne: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeOne?.name
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeOne"]?.[
          "name"
          ]) ?? "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeOne?.relationship
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeOne"]?.[
          "relationship"
          ]) ?? "",
    },
    nomineeTwo: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeTwo?.name
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeTwo"]?.[
          "name"
          ]) ?? "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeTwo?.relationship
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeTwo"]?.[
          "relationship"
          ]) ?? "",
    },
    nomineeThree: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeThree?.name
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeThree"]?.[
          "name"
          ]) ?? "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeThree?.relationship
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeThree"]?.[
          "relationship"
          ]) ?? "",
    },
    nomineeFour: {
      name:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeFour?.name
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeFour"]?.[
          "name"
          ]) ?? "",
      relationship:
        (typeof user?.user?.family_detials == "object"
          ? user?.user?.family_detials?.nomineeFour?.relationship
          : JSON.parse(user?.user?.family_detials || "{}")?.["nomineeFour"]?.[
          "relationship"
          ]) ?? "",
    },
  });


  useEffect(() => {
    if (user?.success && user?.user?.onboarding_step) {
      setLoading(false);
      switch (user?.user?.onboarding_step) {
        case "2":
        case 2:
          setViewContactInfo(true);
          setStepTwo(true);
          setStepThree(false);
          setStepFour(false);
          setStepFive(false);
          setStepNominee(false);
          setStepPlan(false);
          break;

        case "3":
        case 3:
          setViewContactInfo(true);
          setStepTwo(false);
          setStepThree(true);
          setStepFour(false);
          setStepFive(false);
          setStepNominee(false);
          setStepPlan(false);
          break;

        case "4":
        case 4:
          setViewContactInfo(true);
          setStepTwo(false);
          setStepThree(false);
          setStepFour(true);
          setStepFive(false);
          setStepNominee(false);
          setStepPlan(false);
          break;

        case "5":
        case 5:
          setViewContactInfo(true);
          setStepTwo(false);
          setStepThree(false);
          setStepFour(false);
          setStepFive(true);
          setStepNominee(false);
          setStepPlan(false);
          break;

        case "6":
        case 6:
          setViewContactInfo(true);
          setStepTwo(false);
          setStepThree(false);
          setStepFour(false);
          setStepFive(false);
          setStepNominee(true);
          setStepPlan(false);
          break;

        case "7":
        case 7:
          setViewContactInfo(false);
          setStepTwo(false);
          setStepThree(false);
          setStepFour(false);
          setStepFive(false);
          setStepNominee(false);
          setStepPlan(true);
          break;

        default:
          setViewContactInfo(true);
          setStepTwo(true);
          setStepThree(false);
          setStepFour(false);
          setStepFive(false);
          setStepNominee(false);
          setStepPlan(false);
          break;
      }
    } else {
      // localStorage.setItem("popup", "true");
      // navigate("/");
    }

    window.scrollTo(0, 0);
  }, [user]);

  useEffect(() => {
    if (policy_details?.success) {
      setViewContactInfo(true);
      setStepTwo(false);
      setStepThree(false);
      setStepFour(false);
      setStepFive(false);
      setStepNominee(true);
      setStepPlan(false);
    }
  }, [policy_details]);

  const goToStepTwo = () => {
    if (!insured) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
      return;
    }
    if (insured == "YES") {
      if (deductable && provider) {
        setLoading(true);
        dispatch(
          addPolicyDetails({
            token: token,
            insured: insured,
            policyNumber: policyNumber,
            purchaseDate: purchaseDate,
            validUpto: validUpto,
            companyName: companyName,
            currentValue: currentValue,
            provider: provider,
            deductable: deductable,
          })
        );
      } else {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
        return;
      }
    } else {
      setLoading(true);
      dispatch(
        addPolicyDetails({
          token: token,
          insured: insured,
          policyNumber: policyNumber,
          purchaseDate: purchaseDate,
          validUpto: validUpto,
          companyName: companyName,
          currentValue: currentValue,
          provider: provider,
          deductable: deductable,
        })
      );
    }
  };

  const validateEmail = (text) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(text);
  };

  const goToStepThree = () => {
    const {
      isPart,
      associationGroup,
      insuranceType,
      primaryInsured,
      secondAdult,
      firstChild,
      secondChild,
      district,
      type,
      // place,
      email,
    } = familyDetails;

    if (
      !primaryInsured.name ||
      !primaryInsured.dob ||
      !primaryInsured.gender ||
      !primaryInsured.address ||
      !email ||
      ((!district || !type) && user?.user?.onboarding_step == 2) ||
      (isPart === "YES" && !associationGroup)
    ) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 5000);
      return;
    }

    const today = new Date();
    const dob = primaryInsured.dob;
    const [day, month, year] = dob.split("/").map(Number);
    const birthDate = new Date(year, month - 1, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    if (age < 18) {
      setError(true);
      setMessage("Primary insured must be at least 18 years old");
      setTimeout(() => {
        setError(false);
        setMessage(null);
      }, 5000);
      return;
    }

    if (insuranceType === "FAMILY") {
      if (
        (!secondAdult?.dob ||
          !secondAdult?.gender ||
          !secondAdult?.name ||
          !secondAdult?.relationship ||
          !secondAdult?.phone) &&
        (!firstChild?.dob ||
          !firstChild?.gender ||
          !firstChild?.name ||
          !firstChild?.relationship) &&
        (!secondChild.dob ||
          !secondChild.gender ||
          !secondChild.name ||
          !secondChild.relationship)
      ) {
        setError(true);
        setMessage("Complete any of the family member details");
        setTimeout(() => {
          setError(false);
          setMessage(null);
        }, 5000);
        return;
      }

      if (secondAdult.dob) {
        const dob = secondAdult.dob ?? "";
        const [day, month, year] = dob.split("/").map(Number);
        const birthDate = new Date(year, month - 1, day);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        if (age < 18) {
          setError(true);
          setMessage("Second Adult must be at least 18 years old");
          setTimeout(() => {
            setError(false);
            setMessage(null);
          }, 5000);
          return;
        }
      }

      if (firstChild.dob) {
        const dob = firstChild.dob ?? "";
        const [day, month, year] = dob.split("/").map(Number);
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();

        // Calculate age in years
        let ageInYears = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        // Adjust age if birthday hasn't occurred yet this year
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          ageInYears--;
        }

        // Calculate age in days
        const ageInDays = Math.floor(
          (today - birthDate) / (1000 * 60 * 60 * 24)
        );

        // Define min and max age
        const minAgeInDays = 91; // 91 days
        const maxAgeInYears = 24; // 25 years

        if (ageInDays < minAgeInDays || ageInYears > maxAgeInYears) {
          setError(true);
          setMessage("First Child must be between 91 days and 25 years");
          setTimeout(() => {
            setError(false);
            setMessage(null);
          }, 5000);
          return;
        }
      }

      if (secondChild.dob) {
        const dob = secondChild.dob ?? "";
        const [day, month, year] = dob.split("/").map(Number);
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();

        // Calculate age in years
        let ageInYears = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        // Adjust age if birthday hasn't occurred yet this year
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          ageInYears--;
        }

        // Calculate age in days
        const ageInDays = Math.floor(
          (today - birthDate) / (1000 * 60 * 60 * 24)
        );

        // Define min and max age
        const minAgeInDays = 91; // 91 days
        const maxAgeInYears = 24; // 25 years

        if (ageInDays < minAgeInDays || ageInYears > maxAgeInYears) {
          setError(true);
          setMessage("Second Child must be between 91 days and 25 years");
          setTimeout(() => {
            setError(false);
            setMessage(null);
          }, 5000);
          return;
        }
      }
    }

    if (!isChecked) {
      setConsent(true);

      setTimeout(() => {
        setConsent(false);
      }, 5000);
      return;
    }

    if (email && !validateEmail(email)) {
      setEmailValidation(true);
      setTimeout(() => {
        setEmailValidation(false);
      }, 5000);
      return;
    }

    setLoading(true);
    dispatch(
      addFamilyDetails({
        token: token,
        insuranceType: insuranceType,
        familyDetails: familyDetails,
      })
    );
  };

  const goToStepFour = () => {
    if (!isHealthy) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
      return;
    }
    setLoading(true);
    dispatch(
      addHealthCondition({
        token: token,
        isHealthy: isHealthy,
        otherDiseases: otherDiseases,
      })
    );
  };

  const saveNominees = () => {
    const { nomineeOne, nomineeTwo, nomineeThree, nomineeFour } = familyDetails;

    if (
      !nomineeOne.name ||
      !nomineeOne.relationship ||
      (nomineeTwo.name && !nomineeTwo.relationship) ||
      (nomineeThree.name &&
        (!nomineeThree.relationship ||
          !nomineeFour.name ||
          !nomineeFour.relationship))
    ) {
      setError(true);
      if (
        nomineeThree.name &&
        (!nomineeThree.relationship ||
          !nomineeFour.name ||
          !nomineeFour.relationship)
      ) {
        setMessage(
          "The number of nominees must be 1, 2, or 4. Please complete the details for the 4th nominee, to proceed."
        );
      } else {
        setMessage("Complete nominee details and Continue");
      }
      setTimeout(() => {
        setError(false);
        setMessage(null);
      }, 5000);
      return;
    }

    setLoading(true);
    dispatch(
      dispatchNominees({
        token: token,
        familyDetails: familyDetails,
      })

    );
    setStepPlan(false)
  };

  const goToStepPlan = () => {
    if (!isSpecificIllness) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
      return;
    }

    setLoading(true);
    dispatch(
      addSpecificIllness({
        token: token,
        isSpecificIllness: isSpecificIllness,
      })
    );
  };

  useEffect(() => {
    dispatch(updateUserData(token));
  }, []);

  const goToPreTwo = () => {
    setViewContactInfo(true);
    setStepTwo(true);
    setStepThree(false);
    setStepFour(false);
    setStepFive(false);
    setStepNominee(false);
    setStepPlan(false);
  };

  const goToPreThree = () => {
    setViewContactInfo(true);
    setStepTwo(false);
    setStepThree(true);
    setStepFour(false);
    setStepFive(false);
    setStepNominee(false);
    setStepPlan(false);
  };

  const goToPreFive = () => {
    setViewContactInfo(true);
    setStepTwo(false);
    setStepThree(false);
    setStepFour(false);
    setStepFive(true);
    setStepNominee(false);
    setStepPlan(false);
  };

  const goToPreNominee = () => {
    setViewContactInfo(true);
    setStepTwo(false);
    setStepThree(false);
    setStepFour(false);
    setStepFive(false);
    setStepNominee(true);
    setStepPlan(false);
  };

  useEffect(() => {
    const sendRequest = async () => {
      try {
        const response = await axios.patch(
          "https://api.raphacure.co.in/api/v1/auth/signon",
          { patient_id: "HHGDJN56" },
          {
            headers: {
              "x-api-key":
                "K2MZa4RoalYZgAUlHdnqOmP91FDTe43qpaEz1EBfGqgf3bwz0jnLjEHMtFaHgiiO",
            },
          }
        );

        const getBranches = async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${response?.data?.data?.accessToken}`,
            },
          };
          try {
            const response = await axios.get(
              "https://api.raphacure.com/api/v1/vendor?state=kerala"
            );

            setBranches(response?.data?.data?.vendors);
          } catch (err) {
            console.log(err);
          }
        };

        getBranches();

        const getDoctors = async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${response?.data?.data?.accessToken}`,
            },
          };
          try {
            const response = await axios.get(
              "https://api.raphacure.com/api/v1/doctor/specialization",
              config
            );

            setDoctors(response?.data?.data);
          } catch (err) {
            console.log(err);
          }
        };

        getDoctors();
      } catch (err) {
        console.log(err);
      }
    };

    sendRequest();
  }, []);
  return (
    <>
      <div style={{ backgroundColor: "#0e6ebe" }}>
        <Spacing md="120" />
      </div>
      <div className="container" style={{ marginTop: "80px" }}>
        <div className="row">
          <div className={`${viewContactInfo ? "col-lg-12" : "col-lg-12"}`}>
            {stepTwo && (
              <>
                <h2 className="cs_fs_40 cs_medium mb-0" style={{ color: "#0e6ebe" }}>Onboarding</h2>
                <div className="cs_height_42 cs_height_xl_25" />
              </>
            )}
            {stepTwo && (
              <StepTwo
                error={error}
                message={message}
                emailvalidation={emailvalidation}
                consent={consent}
                loading={loading}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                familyDetails={familyDetails}
                setFamilyDetails={setFamilyDetails}
                goToStepThree={goToStepThree}
                user={user?.user}
                goToPreTwo={goToPreTwo}
              />
            )}
            {stepThree && (
              <StepThree
                error={error}
                loading={loading}
                setIsHealthy={setIsHealthy}
                isHealthy={isHealthy}
                otherDiseases={otherDiseases}
                setOtherDiseases={setOtherDiseases}
                goToStepFour={goToStepFour}
                goToPreTwo={goToPreTwo}
                user={user?.user}
              />
            )}
            {stepFour && (
              <StepFour
                error={error}
                loading={loading}
                isSpecificIllness={isSpecificIllness}
                setIsSpecificIllness={setIsSpecificIllness}
                goToStepPlan={goToStepPlan}
              />
            )}
            {stepFive && (
              <StepOne
                error={error}
                loading={loading}
                insured={insured}
                setInsuredValue={setInsuredValue}
                policyNumber={policyNumber}
                setPolicyNumber={setPolicyNumber}
                purchaseDate={purchaseDate}
                setPurchaseDate={setPurchaseDate}
                validUpto={validUpto}
                setValidUpto={setValidUpto}
                companyName={companyName}
                setCompanyName={setCompanyName}
                currentValue={currentValue}
                setCurrentValue={setCurrentValue}
                provider={provider}
                setProvider={setProvider}
                deductable={deductable}
                setDeductable={setDeductable}
                goToStepTwo={goToStepTwo}
                goToPreThree={goToPreThree}
              />
            )}
            {stepNominee && (
              <StepNominee
                loading={loading}
                error={error}
                message={message}
                familyDetails={familyDetails}
                setFamilyDetails={setFamilyDetails}
                saveNominees={saveNominees}
                goToPreFive={goToPreFive}
              />
            )}
            {stepPlan && (
              <StepPlan goToPreNominee={goToPreNominee} back={true} goToPreThree={goToPreThree} goToPreTwo={goToPreTwo} />
            )}
          </div>
          {viewContactInfo && (
            <div className="col-lg-4 offset-lg-1">
              <div className="cs_height_lg_100" />

              {stepTwo && <Stepper index={0} />}
              {stepThree && <Stepper index={1} />}
              {/* {stepFour && <Stepper index={2} />} */}
              {stepFive && <Stepper index={2} />}
              {stepNominee && <Stepper index={3} />}
              {/* {stepTwo && <Stepper index={0} />}

              {stepThree && <Stepper index={1} />}
              {stepFive && <Stepper index={2} />}
              {stepNominee && <Stepper index={3} />}
              {stepPlan && <Stepper index={4} />} */}

              {/* <h2 className="cs_fs_40 cs_medium mb-0">Contact Info</h2>
                            <div className="cs_height_60 cs_height_xl_40" />
                            <img
                                src="/images/appointments/appointment_img.jpeg"
                                alt="Appointment"
                                className="cs_radius_25 w-100"
                            />
                            <div className="cs_height_100 cs_height_xl_60" />
                            <ul className="cs_contact_info cs_style_1 cs_mp0">
                                {contactInfo.map((item, index) => (
                                    <li key={index}>
                                        <h3 className="cs_fs_24 cs_semibold mb-0">{item.title}</h3>
                                        <p className="mb-0 cs_heading_color">{item.subTitle}</p>
                                    </li>
                                ))}
                            </ul> */}
            </div>
          )}
        </div>

        {/* <Spacing md="150" lg="150" xl="150" /> */}
        {/* <Departments data={branches} /> */}

        {/* <Spacing md="100" lg="100" xl="100" /> */}
        {/* <Doctors doctors={doctors} /> */}
      </div>
    </>
  );
}
